import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  captureAttributionParams,
  initClarity,
  isAdminPath,
  setClarityConsent,
  trackCampaignLanding,
} from 'utils/analytics';

/**
 * Bootstrap de analytics: UTMs + Clarity (se REACT_APP_CLARITY_PROJECT_ID).
 * Montar uma vez dentro do BrowserRouter.
 */
const AnalyticsBootstrap = () => {
  const location = useLocation();

  useEffect(() => {
    initClarity();
  }, []);

  useEffect(() => {
    captureAttributionParams();
    // Link de campanha (utm_campaign): GTM + central de eventos (CRM). Dedupe por sessão.
    trackCampaignLanding({ pathname: location.pathname });
  }, [location.search, location.pathname]);

  useEffect(() => {
    setClarityConsent(!isAdminPath(location.pathname));
  }, [location.pathname]);

  return null;
};

export default AnalyticsBootstrap;
